import { BulkActionState } from '../types/reducers/bulk_actions'
import {
    HIDE_BULK_ACTION_MODALS,
    SET_MODAL_DATA,
    SET_OUT_OF_SYNC_IDS,
    SET_PAYLOAD,
    SHOW_BULK_ACTION_MODAL,
} from '../constants/reducers/bulk_actions'
import { Action } from '../constants/reducers/state'

const initialModalState = {
    state: false,
    dailyBudget: false,
    name: false,
    defaultBid: false,
    startDate: false,
    endDate: false,
    bid: false,
    targetAcos: false,
    portfolio: false,
    negative_keywords: false,
    delete: false,
    smart_bid: false,
    out_of_sync: false,
    add_asin_to_ad_group: false,
    add_sku_to_ad_group: false,
    'recipe-delete': false,
}

export const BulkActionInitialState: BulkActionState = {
    payload: {},
    outOfSyncIds: [],
    modalData: {},
    modals: initialModalState,
}

export const bulkActionReducer = (state: BulkActionState, action: Action): BulkActionState => {
    if (typeof state === 'undefined') {
        return BulkActionInitialState
    }

    switch (action.type) {
        case SET_PAYLOAD:
            return Object.assign({}, state, {
                payload: action.payload,
            })
        case SET_OUT_OF_SYNC_IDS:
            return Object.assign({}, state, {
                outOfSyncIds: action.outOfSyncIds,
            })
        case SET_MODAL_DATA:
            return Object.assign({}, state, {
                modalData: action.data,
            })
        case SHOW_BULK_ACTION_MODAL:
            return Object.assign({}, state, {
                modals: {
                    ...initialModalState,
                    [action.modal]: true,
                },
            })
        case HIDE_BULK_ACTION_MODALS:
            return Object.assign({}, state, {
                modals: {
                    ...initialModalState,
                },
            })
        default:
            return state
    }
}
